import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Layout, Button, message, Input } from 'antd';
import PaginatedReduxTableWithHeader from '../common/PaginatedReduxTableWithHeader';
import { fieldTechsRestCrudThunksForSupplier } from '../../thunks/field_techs_thunks';
import { EmptyState } from '../empty_state/EmptyState';
import { FieldTechRowDisplay } from '../field_tech_row_display/FieldTechRowDisplay';
import {
	capitalizeEachWord,
	currencyFormatter,
	formatDateForParam,
	getContactName,
} from '../../utils/DataFormatterUtils';
import { SUPPLIER_ADMIN_ONLY } from '../roles/roles';
import SupplierUserInviteForm from '../supplier_user_invite_form/SupplierUserInviteForm';
import { supplierSignUpInvite } from '../../thunks/supplier_contacts_thunks';
import queryString from 'querystring';
import {
	changeFilterValueToArrayOfIds,
	getEndDateFieldName,
	getStartDateFieldName,
	nullSafeGet,
	nullSafeGetOrElse,
} from '../../utils/DataAccessUtils';
import { getIsActiveFilterField, INITIAL_ACTIVE_FILTERS } from '../../utils/FilterUtils';
import { Form } from '@ant-design/compatible';
import RegionsLocationsTreeSelect from '../regions_tree_select/RegionsLocationsTreeSelect';
import {
	FILTER_CONFIG_NAMES,
	FILTER_FIELD_TYPE,
	FILTER_VALUE_TYPE,
} from '../../utils/DataConstants';
import { getSupervisorsForThirdPartySuppliers } from '../../thunks/contacts_thunks';
import OWAsyncTreeSelect from '../ow_async_tree_select/OWAsyncTreeSelect';
import OWRadioGroup from '../ow_radio_group/OWRadioGroup';
import moment from 'moment';
import OWDateRangePicker from '../ow_date_range_picker/OWDateRangePicker';
import { ASSETS_CRUD_ACTION_CREATORS } from '../../actions/assets_actions';
import { FIELD_TECHS_CRUD_ACTION_CREATORS } from '../../actions/field_techs_actions';

const { Content } = Layout;

const style = require('./FieldTechsIndexPage.less');

const FIELD_TECH_TARGET_COLLECTION = 'fieldTechsIndex';
const SUPERVISOR_TARGET_COLLECTION = 'fieldTechsSupervisorFilter';

class FieldTechsIndexPage extends React.Component<any, any> {
	formRefs: any;
	initialPagination: any = { current: 1, pageSize: 5 };

	constructor(props) {
		super(props);

		const { location } = this.props;
		let searchString = location.search;
		if (searchString[0] === '?') {
			searchString = searchString.slice(1);
		}
		const queryParams = queryString.parse(searchString);
		const { current, pageSize, ...other } = queryParams;
		this.initialPagination = {
			...this.initialPagination,
			current: current ? current : this.initialPagination.current,
			pageSize: pageSize ? pageSize : this.initialPagination.pageSize,
		};
		this.state = {
			visible: false,
		};
		this.handleSupplierUserInviteCancel = this.handleSupplierUserInviteCancel.bind(this);
		this.handleSupplierUserInviteSubmit = this.handleSupplierUserInviteSubmit.bind(this);
		this.showModal = this.showModal.bind(this);
		this.formRefs = {
			userInviteForm: null,
			roleUpdateForm: null,
		};
	}
	setupPagination() {
		const { location } = this.props;
		let searchString = location.search;
		if (searchString[0] === '?') {
			searchString = searchString.slice(1);
		}
		const queryParams = queryString.parse(searchString);
		const { current, pageSize, ...other } = queryParams;
	}

	showModal(e) {
		this.setState({
			visible: true,
		});
	}

	saveFormRef = (formName) => (formRef) => {
		this.formRefs[formName] = formRef;
	};

	handleSupplierUserInviteSubmit(values) {
		const { inviteNewUser } = this.props;
		const contact = {
			...values,
			nameFamily: values.nameFamily || '',
			roles: [values.roles],
		};

		inviteNewUser(contact).then(() => {
			this.setState({ visible: false });
			message.success(`Invite sent to ${contact.nameGiven} at ${contact.email}.`);
		});
	}

	handleSupplierUserInviteCancel(e) {
		this.setState({
			visible: false,
		});
	}

	render() {
		const {
			history,
			currentUser,
			updateFilters,
			clearAndUpdateFilters,
			fieldTechs,
			allContacts,
			fetchSupervisors,
		} = this.props;

		const onRow = (record) => ({
			onClick: () =>
				history.push(`/supplier/fieldTechs/detail/${encodeURIComponent(record.email)}`),
		});

		const filterConfig = [
			{
				label: 'Supervisor',
				fieldName: FILTER_CONFIG_NAMES.SUPERVISOR,
				placeholder: 'Search for a supervisor',
				stateSlice: allContacts,
				fetch: fetchSupervisors,
				renderItem: (record) =>
					getContactName(nullSafeGet('contact', record)).trim() ||
					nullSafeGetOrElse('contact.email', record, ''),
				keyAccessor: (record) => record.email,
				valueAccessor: (record) => record.email,
				sortBy: { sort_by: 'name', order: 'ascend' },
				valueType: FILTER_VALUE_TYPE.STRING,
				mode: null,
				targetCollectionName: SUPERVISOR_TARGET_COLLECTION,
			},
		];

		const columns = [
			{
				title: 'Name',
				dataIndex: 'name',
				sorter: true,
				render: (text, record) => <FieldTechRowDisplay fieldTech={record} />,
			},
			{
				title: 'Role',
				dataIndex: 'role',
				sorter: true,
				render: (text, record) => capitalizeEachWord(text),
			},
			{
				title: 'Rate',
				dataIndex: 'hourlyRate',
				sorter: true,
				render: (text, record) => currencyFormatter()(text),
			},
		];

		return (
			<Content className="fieldTechsIndexPage" style={{ padding: '0 0.5em' }}>
				{/*<ScrollToTopOnMount/>*/}
				{/*<BackTop/>*/}
				<SupplierUserInviteForm
					wrappedComponentRef={this.saveFormRef('userInviteForm')}
					visible={this.state.visible}
					formData={{ roles: 'SUPPLIER_TECH' }}
					isReinvite={false}
					onCancel={this.handleSupplierUserInviteCancel}
					onSubmit={this.handleSupplierUserInviteSubmit}
				/>

				<PaginatedReduxTableWithHeader
					targetCollectionName={FIELD_TECH_TARGET_COLLECTION}
					updateFilters={updateFilters}
					clearAndUpdateFilters={clearAndUpdateFilters}
					stateSlice={fieldTechs}
					filterConfig={filterConfig}
					entityCollectionName="field_techs"
					tableColumns={columns}
					fetchData={fieldTechsRestCrudThunksForSupplier.read}
					onTableRow={onRow}
					initialPagination={this.initialPagination}
					initialSorters={{ sort_by: 'name', order: 'ascend' }}
					rightActions={null}
					emptyState={
						<EmptyState
							graphic={
								<img
									style={{ marginBottom: 8 }}
									src="https://s3.amazonaws.com/mock-data-assets/categories/images/cactus.svg"
								/>
							}
							headline={"It's a little lonely in here."}
							body={
								<div style={{ textAlign: 'center' }}>
									<div style={{ maxWidth: 440, marginBottom: 16 }}>
										Looks like your team has not added any field techs yet.
									</div>
									{currentUser &&
									currentUser.roles.some((role) => SUPPLIER_ADMIN_ONLY.has(role)) ? (
										<Button type="primary" onClick={(e) => this.showModal(e)}>
											Invite your first field technician
										</Button>
									) : null}
								</div>
							}
						/>
					}
				/>
			</Content>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,
	fieldTechs: state.field_techs,
	allContacts: state.all_contacts,
	currentUser: state.session.currentUser,
});

const mapDispatchToProps = (dispatch) => ({
	updateFilters: (filters, targetCollection) =>
		dispatch(FIELD_TECHS_CRUD_ACTION_CREATORS.updateFilters(filters, targetCollection)),
	clearAndUpdateFilters: (filters, targetCollectionName) =>
		dispatch(FIELD_TECHS_CRUD_ACTION_CREATORS.clearAndUpdateFilters(filters, targetCollectionName)),
	inviteNewUser: (contact) => dispatch(supplierSignUpInvite(contact)),
	fetchSupervisors: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			getSupervisorsForThirdPartySuppliers.read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FieldTechsIndexPage));
